import { Injectable } from '@angular/core';
import { STRINGS } from '../../strings';
import { BehaviorSubject, Observable } from 'rxjs';

export enum LANGUAGES {
  english = 'en',
  french = 'fr',
}
export const DEFAULT_LANGUAGE = LANGUAGES.english;

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private language = new BehaviorSubject<LANGUAGES>(DEFAULT_LANGUAGE);

  constructor() {}

  public getLanguage(): Observable<LANGUAGES> {
    return this.language.asObservable();
  }

  public setLanguage(language: LANGUAGES) {
    this.language.next(language);
  }

  public getString(
    key: keyof typeof STRINGS,
    ...values: Array<string>
  ): string {
    return STRINGS[key][this.language.value](values);
  }
}
